import { FC } from 'react';
import styled from 'styled-components';

const Container = styled.div`
    text-align: center;
    padding: 20px;
    font-size: 0.9rem;
    color: ${({ theme }) => theme.palette.text.primary};
`;

const Footer: FC = () => (
    <Container>
        <a
            target="_blank"
            rel="noreferrer"
            href="https://github.com/undeadborn"
        >
            &copy; undeadborn {new Date().getFullYear()}
        </a>
    </Container>
);

export default Footer;
